import { render } from "./ErrorLayout.vue?vue&type=template&id=b8df4be0"
import script from "./ErrorLayout.vue?vue&type=script&lang=js"
export * from "./ErrorLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ErrorLayout.vue"]])

export default __exports__